import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import appearenceService from "./appearanceService";

const initialState = {
  favStateLoading: false,
  favStateSuccess: false,
  favStateError: false,
  fav:"",
  favStateErrorMsg: "",
};

// _______________________createFavSettings response function and services calling
export const createFavSettings = createAsyncThunk(
  "createFavSettings",
  async (data, thunkAPI) => {
    try {
      const response = await appearenceService.createFavSettings(data);
      return response;
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const errorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.errorMsg) ||
        error.errorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const favSettingsSlice = createSlice({
  name: 'favSettings',
  initialState,
  reducers: {
    resetFavSettings: (state) => {
      state.favStateLoading = false;
      state.favStateSuccess = false;
      state.favStateError = false;
      state.favStateErrorMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createFavSettings.pending, (state) => {
        state.favStateLoading = true;
      })
      .addCase(createFavSettings.fulfilled, (state, action) => {
        state.favStateLoading = false;
        state.favStateSuccess = true;
        state.fav = action.payload;
      })
      .addCase(createFavSettings.rejected, (state, action) => {
        state.favStateLoading = false;
        state.favStateError = true;
        state.favStateErrorMsg = action.payload; // error from catch will come here via action.payload and update linkErrorMsg
      });
  },
});
export const { resetFavSettings } = favSettingsSlice.actions;
export default favSettingsSlice.reducer;